module.exports = __webpack_public_path__ + "img/google-docs.d8d8bbc2.svg";